<template>
    <Modal v-model="editPoliciesModal" :title="$t('patch_management.patch_policy.editPolicy')" :loading="loading"  :mask-closable="false" :on-open-modal="editPoliciesModal=true" :closable="false">
        <Form ref="policyEditForm" :model="policyEditForm" :rules="ruleValidate" :label-width="100" >
            <FormItem :label="$t('patch_management.patch_policy.name')" prop="name">
                <Input v-model="policyEditForm.name" placeholder="" style="width:300px;"></Input>
            </FormItem>
            <FormItem :label="$t('patch_management.patch_policy.account')" prop="accountId">
                <Select v-model="policyEditForm.accountId" style="width:300px;" @on-change="changeAccountId(policyEditForm.accountId)" placeholder="">
                    <Option :value="item.id" v-for="(item,index) in accountList" v-bind:key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('patch_management.patch_policy.region')" prop="regionSearchKey">
                <Select v-model="policyEditForm.regionSearchKey" filterable :placeholder="$t('patch_management.patch_policy.queryByRegion')" :transfer="true" style="width:300px;" >
                    <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('patch_management.patch_policy.state')" prop="state">
                <Select v-model="policyEditForm.state" style="width:300px;" placeholder="">
                    <Option :value="item.state" v-for="item in statusList" v-bind:key="item.id">{{item.name}}</Option>
                </Select>
            </FormItem>
            <!-- 提醒时间 -->
            <FormItem :label="$t('patch_management.patch_policy.remindTime')" prop="remindTime">
                <Select v-model="policyEditForm.remindTime" multiple style="width:300px;" @on-change="changeRemindTime(policyEditForm.remindTime)" placeholder="">
                    <Option :value="item.id" v-for="(item,index) in remindTimeList" v-bind:key="index">{{item.name}}</Option>
                </Select>
            </FormItem>

            <!-- 通知对象 -->
            <div v-if="policyEditForm.remindTime!=''">
                <!-- 联系方式 -->
                <FormItem :label="$t('patch_management.patch_policy.contactType')" prop="contactType">
                    <RadioGroup v-model="policyEditForm.contactType" @on-change="changeContactType(policyEditForm.contactType)">
                        <Radio v-for="item in contactTypeList" :label="item.type" :key="item.value">{{item.label}}</Radio>
                    </RadioGroup>
                </FormItem>

                <FormItem :label="$t('patch_management.patch_policy.contactPerson')" prop="notificationObject" v-if="policyEditForm.remindTime!=''&&policyEditForm.contactType==0">
                    <Select v-model="policyEditForm.notificationObject" multiple style="width:300px;" placeholder="">
                      <Option v-for="item in notificationObjectList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 联系人组 -->
                <FormItem :label="$t('patch_management.patch_policy.contactGroup')" prop="contactGroupId" v-if="policyEditForm.remindTime!=''&&policyEditForm.contactType==1">
                    <Select v-model="policyEditForm.contactGroupId" style="width:300px;" placeholder="">
                        <Option v-for="item in contactGroupIdList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
            </div>
            <!-- 审批流 -->
            <FormItem :label="$t('patch_management.patch_policy.approvalFlow')" prop="approvalFlow">
                <div>{{this.processTemplateName}}</div>
            </FormItem>
            <FormItem :label="$t('patch_management.patch_policy.schedule')" prop="scheduleNames">
                <Select v-model="policyEditForm.scheduleNames" style="width:300px;" placeholder="">
                    <Option :value="item.id" v-for="(item,index) in scheduleNameList" v-bind:key="index">{{item.name}}</Option>
                </Select>
            </FormItem>
            <FormItem :label="$t('patch_management.patch_policy.description')" prop="describe">
                <Input v-model="policyEditForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="" style="width:300px;"></Input>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="handleReset('policyEditForm')">{{$t('patch_management.patch_policy.cancel')}}</Button>
            <Button type="primary" @click="handleSubmit('policyEditForm')" :loading="loading" v-hasPermission="['patchManagement:policies:edit']">{{showDetermineName}}</Button>
        </div>
    </Modal>
</template>
<script>

    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import TablePolicies from '../policy/TablePolicies.vue'
    var tablePolicies = TablePolicies;
    export default {
        name: 'EditPolicies',
        props:['policiesEditOldForm'],
        data () {
            return {
                processTemplateName:'',
                contactTypeList: [{
                    label: this.$t('patch_management.patch_policy.contactPerson'),
                    value: 'contact',
                    type: 0
                },
                {
                    label: this.$t('patch_management.patch_policy.contactGroup'),
                    value: 'contactGroup',
                    type: 1
                }],
                showDetermineName:this.$t('patch_management.patch_policy.confirm'),
                notificationObjectList: [],
                remindTimeList:[],
                policyEditForm: {
                    name: '',
                    accountId: '',
                    state: '',
                    textarea: '',
                    regionSearchKey:'',
                    scheduleNames:'',
                    approvalFlow:'',
                    notificationObject: [],
                    remindTime:[],
                    contactType:0,
                    contactGroupId:''
                },
                // 联系人组
                contactGroupIdList:[],
                accountList:[],
                regionList:[], //区域
                scheduleNameList: [],
                statusList: [{
                    id: 1,
                    name:this.$t('alarms.common.enable'),
                    state: 0
                },
                {
                    id: 2,
                    name: this.$t('alarms.common.disable'),
                    state: 1
                }],
                editPoliciesModal: false,
                loading: false,
                ruleValidate: {
                    name: [
                        { required: true, message: this.$t('patch_management.patch_policy.nameRequired'), trigger: 'blur' },
                        { type: 'string', message: this.$t('patch_management.patch_policy.nameLength'), pattern:'^.{4,20}$', trigger: 'blur'}
                    ],
                    remindTime: [
                        { required: false, message: this.$t('patch_management.patch_policy.selectRemindTime'), trigger: 'change',type:'array' }
                    ],
                    notificationObject: [
                        {required: true, type: 'array', message: this.$t('patch_management.patch_policy.selectNotificationObject'), trigger: 'change'}
                    ],
                    approvalFlow: [
                        { required: false, message: this.$t('patch_management.patch_policy.selectApprovalFlow'), trigger: 'change',type:'number' }
                    ],
                    accountId: [
                        { required: true, message: this.$t('patch_management.patch_policy.selectAccountName'), trigger: 'change',type:'number' }
                    ],
                    state: [
                         { required: true, message: this.$t('patch_management.patch_policy.selectState'), trigger: 'change',type:'number' }
                    ],
                    scheduleNames: [
                        { required: true, message: this.$t('patch_management.patch_policy.selectSchedule'), trigger: 'change',type:'number' }
                    ],
                    describe: [
                        { required: false, message: this.$t('common.descriptionRequired'), trigger: 'blur' },
                        { type: 'string', max: 100, message: this.$t('patch_management.patch_policy.maxChars100'), trigger: 'blur' }
                    ],
                    regionSearchKey: [
                        { required: true, message: this.$t('RAM.common.PleaseSelectRegion'), trigger: 'change' }
                    ],
                    contactType: [
                        {required: true, message: this.$t('patch_management.patch_policy.selectContactType'), trigger: 'change', type: 'number'}
                    ],
                    contactGroupId: [
                        {required: true, message: this.$t('patch_management.patch_policy.selectContactGroup'), trigger: 'change', type: 'number'}
                    ]
                }
            }
        },
        mounted:function(){
            this.policiesShow();
        },
        methods:{
            // 根据用户名查询Account列表
            queryAccountsByUsername: function(){
                //根据用户名查询Account列表
                this.$api.account.selectAccountByCloudPlatform("type",0)
                    .then(res => {
                        this.accountList = res.data;
                    })
            },
             // 区域
            queryAccountRegions:function(){
                if (this.policyEditForm.accountId == "" || this.policyEditForm.accountId == null ) {
                    return;
                }
                this.$api.account.queryAccountRegions("accountId",this.policyEditForm.accountId)
                .then(res => {
                    this.regionList = res.data;
                })
            },
            // 切换账户
            changeAccountId: function(){
                this.queryAccountRegions();
            },
            // 提醒时间
            getRemindTime:function(){
                this.$api.policy.getRemindTime("userName",getCookie(global.cookieName))
                .then(res => {
                    this.remindTimeList = res.data;
                })
            },
            // 切换提醒时间
            changeRemindTime:function(){
                if(this.policyEditForm.remindTime.length===0){
                    this.policyEditForm.notificationObject=[];
                }
                this.$api.contact.queryContacts("monitorModule", 22)
                .then(res => {
                    this.notificationObjectList = res.data.contactList;
                })
            },
            // 切换审批流
            changeApprovalFlow:function(){
                // 如果不选审批流 显示确定 否则显示提交
                if(this.policyEditForm.approvalFlow==''){
                    this.showDetermineName=this.$t('patch_management.patch_policy.confirm')
                }else{
                    this.showDetermineName=this.$t('patch_management.patch_policy.submit')
                }
            },
            // 切换联系方式
            changeContactType:function(){
                if(this.policyEditForm.contactType===1){
                    this.$api.contactGroup.listContactGroups()
                    .then(res => {
                        this.contactGroupIdList = res.data;
                    })
                }
            },
            policiesShow:function(){
                this.getRemindTime();
                this.queryAccountsByUsername();
                this.showDetermineName=this.$t('patch_management.patch_policy.confirm');
                //当前行id
                this.policyEditForm.id=this.policiesEditOldForm.id;
                //名称
                this.policyEditForm.name=this.policiesEditOldForm.name;
                //账户
                this.policyEditForm.accountId=this.policiesEditOldForm.accountId;
                //区域
                this.policyEditForm.regionSearchKey=this.policiesEditOldForm.region;

                //提醒时间
                if(this.policiesEditOldForm.reminds==undefined){
                    this.policyEditForm.remindTime=[];
                }else{
                    this.policyEditForm.remindTime=this.policiesEditOldForm.reminds;
                }

                // 联系方式
                this.policyEditForm.contactType = this.policiesEditOldForm.contactType;
                if(this.policiesEditOldForm.contactType==0){
                    // 通知对象
                    this.policyEditForm.notificationObject=this.policiesEditOldForm.contactIDs;
                }else if(this.policiesEditOldForm.contactType==1){
                    // 联系人组
                    this.$api.contactGroup.listContactGroups()
                    .then(res => {
                        this.contactGroupIdList = res.data;
                    })
                    setTimeout(() => {
                        this.policyEditForm.contactGroupId = this.policiesEditOldForm.contactGroupId;
                    }, 1000)
                }

                // 审批流
                this.policyEditForm.approvalFlow=this.policiesEditOldForm.processTemplateId;
                this.processTemplateName=this.policiesEditOldForm.processTemplateName;
                this.queryAccountRegions();
                //日程
                //根据用户名查询Account列表
                this.$api.scheduleManagement.querySchedulesByUserName("userName",getCookie(global.cookieName))
                .then(res => {
                    this.scheduleNameList = res.data;
                })

                this.policyEditForm.scheduleNames=this.policiesEditOldForm.scheduleManagementId;
                //状态
                /***********************************************************************/
                this.policyEditForm.state=this.policiesEditOldForm.state;
                // 描述
                this.policyEditForm.describe=this.policiesEditOldForm.description;
            },
            handleSubmit: function(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        var policyData={
                            "id": this.policyEditForm.id,
                            "name": this.policyEditForm.name,
                            "accountId": this.policyEditForm.accountId,
                            "region":this.policyEditForm.regionSearchKey,
                            "scheduleManagementId": this.policyEditForm.scheduleNames,
                            "description": this.policyEditForm.describe,
                            "state": this.policyEditForm.state,
                            "reminds": this.policyEditForm.remindTime,
                            "processTemplateId":this.policyEditForm.approvalFlow,
                            "contactType":this.policyEditForm.contactType
                        };

                        // 如果联系方式是联系人 传通知对象
                        if(this.policyEditForm.contactType == 0){
                            policyData.contactIDs = this.policyEditForm.notificationObject;
                        }
                        // 如果联系方式是联系人组 传联系人组
                        else if(this.policyEditForm.contactType == 1){
                            policyData.contactGroupId = this.policyEditForm.contactGroupId;
                        }

                        this.$api.policy.updatePolicy(policyData)
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                // 子组件引用父组件methods里面的方法
                                this.$parent.showAll();
                                this.$refs[name].resetFields();//清空表格内的我们填写的数据
                                this.loading = false;
                                this.$Message.success(this.$t('common.editSuccess'));
                                this.regionList=[];
                                this.$emit("on-close-cancel",false);
                                this.editPoliciesModal = false;
                            }, 1000);
                        })
                    }
                    else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            handleReset: function(name) {
                this.regionList=[];
                this.loading = false;
                this.$emit("on-close-cancel",false);
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
    .addPolicies-main
    {
        width: 300px;
        min-height: 100px;
        border: 1px solid #dcdee2;
        border-radius: 4px;
    }
    .addPolicies-main>div
    {
        margin-left: 8px;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/EditPolicies.vue